import { TOGGLE_SHOW_GUIDES } from 'modules/editor/store/constants';

export const toggleShowGuides = (showGuides = false) => ({
  type: TOGGLE_SHOW_GUIDES,
  payload: {
    showGuides,
  },
});
